import { render, staticRenderFns } from "./LiveScoreModal.vue?vue&type=template&id=41fdd1de&scoped=true"
import script from "./LiveScoreModal.vue?vue&type=script&lang=js"
export * from "./LiveScoreModal.vue?vue&type=script&lang=js"
import style0 from "./LiveScoreModal.vue?vue&type=style&index=0&id=41fdd1de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fdd1de",
  null
  
)

export default component.exports